import { useRef } from "react";

export default function UIStepsCard({ thumbnail, index, squareIndex = false, imageSrc, title, description, className, style, color, link }) {
  const elementRef = useRef(null);
  return (
    <div
      className={`flex flex-col justify-start items-center ${link ? "cursor-pointer":"cursor-default"} border-b-4  rounded-xl hover:-translate-y-1 hover:shadow-lg duration-700 transition-all transform-gpu w-full  shadow-[0_0_12px_1px_rgba(57,62,100,.1)] ${className}`}
      // className={`${squareIndex ? 'border border-gray-700' : 'border-b-4 rounded-xl'} hover:-translate-y-1 hover:shadow-lg duration-700 transition-all transform-gpu w-full md:max-w-[309px] shadow-sm ${className}`}
      style={{...style,borderColor:color}}
      onClick={ link ? ()=>window.open(link) :undefined}
    >
      
      <div
        ref={elementRef}
        className={`w-full h-[120px] bg-cover bg-no-repeat bg-center ${squareIndex ? '' : 'rounded-t-lg'}`}
        style={{
          backgroundImage: `url(${thumbnail})`,
        }}
      />
      <div className={`${squareIndex ? 'border-t-0 border border-gray-700' : ''} relative px-6 py-9 flex-1 w-full`}>
        {squareIndex ? (
          <div className="absolute top-[-20px] border border-gray-700">
            <img
              src={imageSrc}
              alt={`index-${index}`}
              className="w-[38px] h-[38px]"
            />
          </div>  
        ) : (
          <div style={{color:color}} className={`absolute top-[-20px] border-bottom-2 font-bold text-[24px] bg-white ${squareIndex ? 'border border-gray-700' : 'rounded-full'} items-center justify-center flex h-[38px] w-[38px]`}>
            {index}
          </div>
        )}
        <div className="font-BNPPSquareBold text-[#474747] mb-[10px] mt-[-10px] font-bold text-[20px]">
          {title}
        </div>
        <div className="font-OpenSans text-[#474747]">{description}</div>
      </div>
    </div>
  );
}

